import { ref, computed } from 'vue'
import { useUserStore } from '../../../stores/user'

export const useUser = () => {
  const isLoading = ref(false)
  const userStore = useUserStore()

  const fetchUser = async () => {
    if (userStore.user) {
      return
    }
    isLoading.value = true
    await userStore.getUserInfo()
    isLoading.value = false
  }
  const user = computed(() => {
    return userStore.user
  })
  const error = computed(() => {
    return userStore.error
  })

  //fetchUser()

  return {
    isLoading,
    fetchUser,
    clearUserState: userStore.clearUserState,
    user,
    error,
  }
}
